import FocalPointWidget from '../components/FocalPoint/FocalPointWidget';

// Crop every image around its focal point (asaj.site.focal_point), wherever
// it's rendered: VLT teasers, listings and the home page templates all use
// the registered Image component.
export default function install(config) {
  const BaseImage = config.getComponent('Image').component;

  const FocalImage = (props) => {
    const focalPoint = props.item?.focal_point;
    if (!focalPoint) return <BaseImage {...props} />;
    return (
      <BaseImage
        {...props}
        style={{ ...props.style, objectPosition: focalPoint }}
      />
    );
  };

  config.registerComponent({ name: 'Image', component: FocalImage });
  config.widgets.widget.focalPoint = FocalPointWidget;

  return config;
}
